var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveTermQuote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16929",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12564",
    d: "M6 7.583l-2.677 2.466a1 1 0 00.116 1.563l7.442 5.043a2 2 0 002.246 0l7.435-5.039a1 1 0 00.112-1.567L18 7.619"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12565",
    d: "M3 10.75v9.225A1.013 1.013 0 004 21h16a1.013 1.013 0 001-1.025V10.75"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12566",
    d: "M3.3 20.7l5.47-5.47"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12567",
    d: "M15.23 15.23l5.47 5.47"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12568",
    d: "M18 13.278V4a1 1 0 00-1-1H7a1 1 0 00-1 1v9.278"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12576",
    d: "M12 13s3-1.44 3-3.6V6.88l-2.188-.787a2.39 2.39 0 00-1.626 0L9 6.88V9.4c0 2.16 3 3.6 3 3.6z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12570",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}
export default SvgSaveTermQuote;


//////////////////
// WEBPACK FOOTER
// ./src/icons/SaveTermQuote.svg
// module id = 729
// module chunks = 13